/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// import AsyncStorage from '@callstack/async-storage'
import {ASYNC_KEY, jnDecrypt} from '../util/General'

//var userSingleton = null
export default class Singleton {
  
  static instance = Singleton.instance || new Singleton()
  

  // function createInstance() {
  //     var object = {};
  //     return object;
  // }

  
  // getInstance() {
  //     if (!instance) {
  //         instance = createInstance();
  //     }
  //     console.log(">> instance", instance)
  //     return instance;
  // }
  
}

export const isAuthenticated = async () => {
  try {
    const value = await localStorage.getItem(ASYNC_KEY.IS_LOGIN);
    return value
  } catch (error) {    
    return false
  }
}

export const storeToken = (token) => {
  Singleton.instance.user = {username: 'haha'}
  localStorage.setItem(ASYNC_KEY.ACCESS_TOKEN, token)  
}

export const logout = () => {
  localStorage.setItem(ASYNC_KEY.IS_LOGIN, false)
  localStorage.setItem(ASYNC_KEY.ACCESS_TOKEN, null)
  localStorage.setItem(ASYNC_KEY.USER, null)
  window.location.href = "/#/";
  window.location.reload();
}

export const storeUserInfo = async (data) => {
  localStorage.setItem(ASYNC_KEY.USER, data)
  localStorage.setItem(ASYNC_KEY.IS_LOGIN, true)
  await getUser()
  window.location.reload();
}

export const Whoami = () => {  
  console.log(">Singleton.instance", Singleton.instance)
  return Singleton.instance.user  
}

export const getUser = async () => {
  // var user = Singleton.getInstance().user
  // if(user == null || user == undefined){
    // return user
//  }
  let user = await localStorage.getItem(ASYNC_KEY.USER);

  console.log('> user 1', user)

  let userDecrypted = null;
  if (user != null && user != 'null') {
    userDecrypted = await jnDecrypt(user);
  }
  //userSingleton = userDecrypted
  Singleton.instance.user = userDecrypted
  return userDecrypted;
}
